import { render } from "./Sending.vue?vue&type=template&id=a55069e0&ts=true"
import script from "./Sending.vue?vue&type=script&lang=ts"
export * from "./Sending.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__